import { mergeStyleSets } from "@fluentui/react";
import { CSSProperties } from "react";
import { CustomCardProps } from "../../SharedComponents/Interfaces/CustomCard.interfaces";

export const communityDetailsStyles = mergeStyleSets({
  customCardContainerAdjustedHeight: {
    height: "calc(100% - 9px)"
  } as CSSProperties,
  grid: {
    display: "grid",
    gridTemplateColumns: "auto 10px auto", // name | colon | status
    gap: "8px", // row gap | column gap
    padding: "16px",
    listStyle: "none",
    margin: 0
  } as CSSProperties,
  // Make each <li> not create its own box; its children flow into the parent grid cells
  row: {
    display: "contents"
  } as CSSProperties,
  name: {
    alignSelf: "center",
    padding: "10px 12px",
    fontWeight: 600
  } as CSSProperties,
  colon: {
    alignSelf: "center",
    textAlign: "center",
    fontWeight: 700
  } as CSSProperties,
  status: {
    textAlign: "center",
    alignSelf: "center",
    fontSize: "1.3rem",
    marginTop: "5px"
  } as CSSProperties
});

export const annotationCustomCardStyles: CustomCardProps["styles"] = {
  root: { flex: 1, minHeight: "20%", height: "inherit", width: "100%" },
  cardHeaderStart: { flex: 1 },
  cardHeaderTitleContainer: { flex: 1 },
  cardDetails: { height: "100%" }
};
